import { render, staticRenderFns } from "./author-avatar-info.vue?vue&type=template&id=6d0f9a1f&scoped=true&"
import script from "./author-avatar-info.vue?vue&type=script&lang=ts&"
export * from "./author-avatar-info.vue?vue&type=script&lang=ts&"
import style0 from "./author-avatar-info.vue?vue&type=style&index=0&id=6d0f9a1f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0f9a1f",
  null
  
)

export default component.exports